import { useCallback } from 'react';

import { WIDGET_NAMES } from '../constants';

const closeInbox = () => {
    if (window.Communication?.API?.inbox?.getWindowStatus()?.open) {
        window.Communication.API.inbox.minimize();
    }
};

export const useCloseOtherWidgets = (
    setBalanceOpened: (isOpened: boolean) => void,
    setQuickDepositOpened: (isOpened: boolean) => void
) =>
    useCallback((widget?: `${WIDGET_NAMES}`) => {
        switch (widget) {
            case WIDGET_NAMES.QUICK_DEPOSIT:
                setBalanceOpened(false);
                closeInbox();
                break;

            case WIDGET_NAMES.BALANCE:
                setQuickDepositOpened(false);
                closeInbox();
                break;

            case WIDGET_NAMES.INBOX:
                setBalanceOpened(false);
                setQuickDepositOpened(false);
                break;

            default:
                setBalanceOpened(false);
                setQuickDepositOpened(false);
                closeInbox();
                break;
        }
    }, [setBalanceOpened, setQuickDepositOpened]);
